import React, {useEffect, useState} from 'react';
import formatNumber from "../../utils/formatNumber";
import feather from "feather-icons";
import {teamReport} from "../../api/app";
const $ = window.$;

const Social = (props) => {
    const [report, setReport] = useState([]);

    useEffect(() => {
        feather.replace();
    }, []);

    return (
        <div className="col-12 col-lg-12">
            <div className="card mg-b-10">
                <div className="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                    <div>
                        <h6 className="mg-b-5">Social Metric</h6>
                        <p className="tx-13 tx-color-03 mg-b-0">Performance.</p>
                    </div>
                </div>

                <div className="card-body pd-y-30">
                    <div className="d-sm-flex">
                        <div className="media align-items-center">
                            <div className="wd-50 wd-md-50 ht-50 ht-md-50 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6" style={{backgroundColor: "#1877F2"}}>
                                <i className="fab fa-facebook tx-30"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap">Facebook</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">0</h4>
                            </div>
                        </div>
                        <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                            <div className="wd-50 wd-md-50 ht-50 ht-md-50 bg-black-9 tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                <i className="fab fa-tiktok tx-30"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">TikTok</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                            </div>
                        </div>
                        <div className="media align-items-center mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                            <div className="wd-50 wd-md-50 ht-50 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                <i className="fab fa-twitter tx-30"></i>
                            </div>
                            <div className="media-body">
                                <h6 className="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Twitter</h6>
                                <h4 className="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0" id="total-assignment">0</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-dashboard mg-b-0">
                        <thead>
                        <tr>
                            <th>Social Platform</th>
                            <th className="text-right">Reach</th>
                            <th className="text-right">Engagement</th>
                            <th className="text-right">Views</th>
                            <th className="text-right">Shares</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="tx-color-03 tx-normal text-capitalize tx-primary"><i className="fab fa-facebook mg-r-4"></i>Facebook</td>
                            <td className="tx-medium text-right">0</td>
                            <td className="text-right tx-medium tx-primary">0</td>
                            <td className="text-right tx-medium tx-pink">0</td>
                            <td className="text-right tx-medium tx-purple">0</td>
                        </tr>

                        <tr>
                            <td className="tx-color-03 tx-normal text-capitalize" style={{color: "black"}}><i className="fab fa-tiktok mg-r-4"></i>Tiktok</td>
                            <td className="tx-medium text-right">0</td>
                            <td className="text-right tx-medium tx-primary">0</td>
                            <td className="text-right tx-medium tx-pink">0</td>
                            <td className="text-right tx-medium tx-purple">0</td>
                        </tr>

                        <tr>
                            <td className="tx-color-03 tx-normal text-capitalize tx-primary"><i className="fab fa-twitter mg-r-4"></i>Twitter</td>
                            <td className="tx-medium text-right">0</td>
                            <td className="text-right tx-medium tx-primary">0</td>
                            <td className="text-right tx-medium tx-pink">0</td>
                            <td className="text-right tx-medium tx-purple">0</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Social;
